import _Promise from 'babel-runtime/core-js/promise';
import { withServiceImplementation } from '@myaccount/utils';

import IBalanceAndBonusDataLayer from './BalanceAndBonusDataLayerInterface';

export default withServiceImplementation(IBalanceAndBonusDataLayer, {
  get: function get(props) {
    return function () {
      var totalBalance = props.totalBalance,
          totalBonus = props.totalBonus,
          balanceWithBonus = props.balanceWithBonus;

      return _Promise.resolve({
        data: {
          balance: {
            totalBalance: totalBalance,
            balanceWithBonus: balanceWithBonus
          },
          bonus: {
            totalBonus: totalBonus
          }
        }
      });
    };
  }
});